/**
 * @module lib/audience/referrer
 */
import logger from "utils/logger";
import { isAnonymous } from "lib/identity/api";
import { isMobile } from "utils/detect";
import tgamConfig from "config/tgam";
import values from "lodash/values";
import { getProp } from "utils/utils";

const debugTag = "[REFERRER]";

/**
 * @method getHost
 * @description Get the host value
 * @param {String} [uri=""]
 * @returns {String}
 */
function getHost(uri = "") {
  if (uri === "" || !uri.includes("://")) {
    return uri;
  }
  let partial = uri.split("://")[1].replace("www.", "");
  if (partial.indexOf("/") !== -1) {
    partial = partial.split("/")[0];
  }
  return partial;
}

/**
 * @method isInternalReferrer
 * @description determines whether the referring page was internal TGAM page
 * @param {String} [ref = window.document.referrer]
 * @returns {Boolean} true when positive
 */
function isInternalReferrer(ref = window.document.referrer) {
  return /theglobeandmail\.com/im.test(ref);
}

/**
 * @method get
 * @description Get the full and host values
 * @param {String} [uri=window.document.referrer]
 * @returns {Object}
 */
export function get(uri = window.document.referrer) {
  return isInternalReferrer(uri) ? {
    full: "",
    host: ""
  } : {
    full: uri,
    host: getHost(uri)
  };
}

/**
 * @method isSocialReferrer
 * @description Return true when the user is a socially referred to a page.
 * @param {String} [ref = window.document.referrer]
 * @param {String} [search = window.location.search]
 * @returns {Boolean}
 */
export function isSocialReferrer(ref = window.document.referrer, search = window.location.search) {
  // Show social stories dropdown if ...
  // - is mobile device
  // - is anonymous user
  // - is not an internal TGAM site referrer
  // - is not an external Newsletter referrer
  // - is not an ADV sponsored article
  const show = {
    isMobile: isMobile(),
    isAnonymous: isAnonymous(),
    isNotInternalReferrer: !isInternalReferrer(ref),
    isNotNewsletterReferrer: !search.includes("utm_medium=Newsletter"),
    isNotAdv: !getProp(tgamConfig, "meta.advContent", false)
  };
  const ret = values(show).every(item => item === true);
  logger.info(`${debugTag} is social referrer`, ret, show);
  return ret;
}
